import { react2angular } from 'react2angular'
import CarListView from './CarListView'

angular.module('webtip.module')
  .component('carListGridletVale', react2angular(CarListView,[],['fleetService', 'CommonService', 'CarService', '$state']))
